import React from 'react'

const Loading = () => (
  <div className="container text-center" title="Loading...">
    <i className="fas fa-sync fa-spin"></i>
  </div>
)

export default Loading
